<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100 mb-2">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">User-wise</h6>
          </div>
          <div class="row">
            <div class="col-md-5 form-group">
              <date-range-picker
                  style="width: 100%;"
                  ref="picker"
                  class="form-control"
                  :opens="dateRangeConf.opens"
                  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                  :minDate="dateRangeConf.minDate" :maxDate="dateRangeConf.maxDate"
                  :singleDatePicker="dateRangeConf.singleDatePicker"
                  :timePicker="dateRangeConf.timePicker"
                  :timePicker24Hour="dateRangeConf.timePicker24Hour"
                  :showWeekNumbers="dateRangeConf.showWeekNumbers"
                  :showDropdowns="dateRangeConf.showDropdowns"
                  :autoApply="dateRangeConf.autoApply"
                  v-model="expiryDate"
                  @update="getOnLoadMessageLogs"
              > <!-- @change="getOnLoadMessageLogs" -->
              </date-range-picker>
            </div>
            <div class="col-md-5 form-group">
              <div class="number-select-wrap" ref="numberSelectWrap">
                <div class="select2-like" @click="numberDropdownOpen = true">
                  <div class="select2-like-chips">
                    <span v-if="integrated_numbers.length === 0" class="select2-like-placeholder">Select numbers</span>
                    <span v-for="id in integrated_numbers" :key="id" class="select2-like-chip">
                      {{ getPhoneLabelById(id) }}
                      <button type="button" class="chip-close" @click.stop="removeSelectedNumber(id)">x</button>
                    </span>
                    <input
                      v-model="numberSearch"
                      class="select2-like-input"
                      type="text"
                      placeholder="Search numbers"
                      @focus="numberDropdownOpen = true"
                      @click.stop
                    />
                  </div>
                  <button v-if="integrated_numbers.length > 0" type="button" class="select2-like-clear" @click.stop="clearSelectedNumbers">Clear</button>
                </div>
                <div v-if="numberDropdownOpen" class="select2-like-dropdown">
                  <label v-for="option in filteredPhoneOptions()" :key="option.phonenumberId" class="select2-like-option">
                    <input
                      type="checkbox"
                      :checked="isNumberSelected(option.phonenumberId)"
                      @change="toggleNumberSelection(option.phonenumberId)"
                    />
                    {{ option.name }} (+91 {{ option.phonenumber }})
                  </label>
                  <div v-if="filteredPhoneOptions().length === 0" class="select2-like-empty">No numbers found</div>
                </div>
              </div>
            </div>
            <div class="col-md-2 form-group d-flex align-items-start justify-content-md-end">
              <button v-if="tables.length > 0" @click="downloadExcel" class="btn btn-success">Download Excel</button>
            </div>
          </div>
        </div>
        <!-- Modal Structure -->
        <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabel">{{ modal_title }}</h5>
                <button type="button" class="btn-close" @click="closeModal" aria-label="Close">X</button>
              </div>
              <div class="modal-body">
                <p class="blink_var" style="
    border: 1px solid;
    border-radius: 10px;
    text-align: center;
    padding: 5px;
    background-color: aliceblue;
" v-html="this.preview"></p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
                <!--                <button type="button" class="btn btn-primary">Save changes</button>-->
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="text-bold">
            <tr>
              <th scope="col">SENT BY</th>
              <th scope="col">SUBMITTED</th>
              <th scope="col">DELIVERED</th>
              <th scope="col">READ</th>
              <th scope="col">TOTAL</th>
              <th scope="col">PRICING</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tables" :key="row.username">
              <td>{{ row.username }}</td>
              <td>{{ row.submitted }}</td>
              <td>{{ row.delivered }}</td>
              <td>{{ row.read }}</td>
              <td>{{ Number(row.delivered) + Number(row.read) }}</td>
              <td>{{ ((Number(row.delivered) + Number(row.read)) * 0.115).toFixed(3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import DateRangePicker from 'daterange-picker-vue3'
//you need to import the CSS manually
import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'
import * as XLSX from "xlsx";

export default {
  components: {
    DateRangePicker
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    // 15th two months prior
    // const minDate = new Date(today)
    // minDate.setMonth(minDate.getMonth() - 2)
    // minDate.setDate(15)

    // 15th in two months
    const maxDate = new Date(today)
    const nextFollowDate = new Date()
    const yesterdayDate = new Date()
    const sevenDate = new Date()
    // maxDate.setMonth(maxDate.getMonth() + 2)
    // maxDate.setDate(now.getDate() + 15)
    nextFollowDate.setDate(now.getDate() + 3)
    yesterdayDate.setDate(now.getDate() - 1)
    sevenDate.setDate(now.getDate() - 7)
    return {
      dateRangeConf: {
        opens: 'center',
        minDate: 'center',
        maxDate: maxDate,
        singleDatePicker: false,
        timePicker: false,
        timePicker24Hour: false,
        showWeekNumbers: false,
        showDropdowns: false,
        autoApply: false,
      },
      expiryDate: {
        'startDate': maxDate,
        'endDate': maxDate
      },
      form: {
        template: 'hellow_world',
        campaign: 'campaign',
        referrel: 'referrel',
        source: 'source',
        fileUpload: null,
      },
      tables: [],
      phones: [],
      waId: "",
      integrated_numbers: [],
      numberSearch: "",
      numberDropdownOpen: false,
      show: true,
      preview: "",
      isOpen: false,
      modal_title: ""
    }
  },
  async created() {
    this.waId = this.$route.params.waId
    var getWaId = await this.getNumberIntegrationList();
    this.phones = getWaId.data.message;
    // if (!this.integrated_number && this.phones.length > 0) {
    //   this.integrated_number = this.phones[0].phonenumberId;
    // }
    var getTemp = await this.getMessageAnalytics();
    this.tables = this.cumulateUserWise(getTemp.data || []);
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    downloadExcel() {
      const data = this.tables.map((row) => ({
        sent_by: row.username,
        submitted: row.submitted,
        delivered: row.delivered,
        read: row.read,
        total: Number(row.delivered) + Number(row.read),
        pricing: ((Number(row.delivered) + Number(row.read)) * 0.115).toFixed(3)
      }));

      const filename = "USER_WISE_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, filename);
    },
    async getFailedList(data, status = "failed") {
      const getCOnfirm = confirm(`Do you need ${status} numbers list?`);
      if (getCOnfirm) {
        const templateURL = '/whatsApp/get_failed_message';
        const getPrev = await this.axiosRequest(templateURL, {
          from: data.from,
          template: data.template,
          status: status,
          random: data.random
        });
        if (getPrev.data.length > 0) {
          // var filename = "FAILED_" + data.from + "_" + data.template + "_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
          var filename = status.toUpperCase() + "_" + data.from + "_" + data.template + "_" + getPrev.data.length + "_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
          var ws = XLSX.utils.json_to_sheet(getPrev.data);
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          XLSX.writeFile(wb, filename);
        } else {
          alert(`no ${status} numbers!`)
        }
      }
    },
    async getTemplateView(data) {
      this.preview = ""
      this.modal_title = data.from + " - " + data.template
      const templateURL = '/whatsApp/get_template_view';
      const getPrev = await this.axiosRequest(templateURL, {
        from: data.from,
        template: data.template,
        random: data.random
      });
      if (getPrev.data.status && getPrev.data.data.data.length > 0) {
        console.log("yes")
        var strReplace = "";
        var obj = {};
        var tempPreview = []
        getPrev.data.data.data[0].components.forEach((value1) => {
          if (Object.prototype.hasOwnProperty.call(value1, "example")) {
            if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'image') {
              obj['HEADER_IMAGE'] = value1.example.header_handle;
              strReplace = value1.example.header_handle;
              tempPreview.push("<span class='header header_image'>" + "<img src='" + strReplace + "' width='335' height='300'></span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_handle") && (value1.format).toLowerCase() == 'video') {
              obj['HEADER_VIDEO'] = value1.example.header_handle;
              strReplace = value1.example.header_handle;
              tempPreview.push("<span class='header header_video'>" + "<iframe src='" + strReplace + "' width='335' height='300'></iframe></span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "header_text")) {
              obj['HEADER_TEXT'] = value1.example.header_text;
              if (value1.text.includes("<i>{{"))
                strReplace = value1.text
              else
                strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
              tempPreview.push("<span class='header header_text font-weight-bold'>" + strReplace + "</span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "body_text")) {
              obj['BODY_TEXT'] = value1.example.body_text[0];
              if (value1.text.includes("<i>{{"))
                strReplace = value1.text
              else
                strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
              tempPreview.push("<span class='body body_text font-weight-bold'>" + strReplace + "</span>")
            } else if (Object.prototype.hasOwnProperty.call(value1.example, "footer_text")) {
              obj['FOOTER_TEXT'] = value1.example.footer_text;
              if (value1.text.includes("<i>{{"))
                strReplace = value1.text
              else
                strReplace = value1.text.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>");
              tempPreview.push("<span class='footer footer_text font-weight-bold'>" + strReplace + "</span>")
            }
          } else {
            if (value1.type == "BUTTONS") {
              var strReplaceBtn = "";
              var objUrl = [];
              value1.buttons.forEach((valueBtn) => {
                if (Object.prototype.hasOwnProperty.call(valueBtn, "example") && valueBtn.url.includes('{{')) {
                  if (valueBtn.type == 'URL')
                      // obj['BUTTON_URL'] = valueBtn.example;
                    objUrl.push(valueBtn.example);
                  else
                    obj['BUTTON_PAYLOAD'] = valueBtn.example;
                  strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "<br> [URL : " + valueBtn.url.replaceAll("{{", "<i class='class_i'>{{").replaceAll("}}", "}}</i>") + "]</span></center>";
                } else {
                  strReplaceBtn += "<center><span class='buttons font-weight-bold text-decoration-underline text-info text-justify'>" + valueBtn.text + "</span></center>";
                }
              });
              obj['BUTTON_URL'] = objUrl; // extra added
              strReplace = strReplaceBtn;
            } else
              strReplace = "<span class='font-weight-bold'>" + value1.text + "</span>";
            tempPreview.push(strReplace);
          }
          // this.templates[this.form.template].components[index1].text = strReplace;
        })
        this.preview = tempPreview.join('<br><br>');
        setTimeout(() => {
          var previewData = getPrev.data.previewData
          console.log(previewData)
          previewData.forEach(component => {
            component.values.forEach((item, index) => {
              if (item.type === "text") {
                let selector = `span.${component.type}_${item.type} i:nth-child(${index + 1})`;
                let el = document.querySelector(selector);
                if (el) {
                  el.innerHTML = item.value;
                  el.style.color = this.getRandomRed();
                }
              } else if (item.type === "image") {
                let selector = `span.${component.type}_${item.type} img:nth-child(${index + 1})`;
                let el = document.querySelector(selector);
                if (el) {
                  el.src = item.value;
                  // el.style.color = this.getRandomRed();
                }
              } if (item.type === "text" && component.type === "button") {
                let selector = `span.${component.type}s i:nth-of-type(${index + 1})`;
                let el = document.querySelector(selector);
                if (el) {
                  el.innerHTML = item.value;
                  el.style.color = this.getRandomRed();
                }
              }
            });
          });
        }, 500)
      } else {
        console.log("no")
        this.preview = "<span>No template found!., Contact your admin</span><br><br>";
      }
      this.isOpen = true
      const modalElement = document.getElementById('myModal');
      modalElement.classList.add('show');
      modalElement.style.display = 'block'; // Show the modal
      document.body.classList.add('modal-open'); // Prevent background scrolling
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop); // Add backdrop
    },
    getRandomRed() {
      let r = 150 + Math.floor(Math.random() * 106); // 150–255 (strong red)
      let g = Math.floor(Math.random() * 80);        // low green
      let b = Math.floor(Math.random() * 80);        // low blue
      return `rgb(${r}, ${g}, ${b})`;
    },
    closeModal() {
      const modalElement = document.getElementById('myModal');
      modalElement.classList.remove('show');
      modalElement.style.display = 'none'; // Hide the modal
      document.body.classList.remove('modal-open'); // Allow background scrolling
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove(); // Remove backdrop
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm:ss a')
      }
    },
    async getMessageAnalytics() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/message_user_pricing';
      return await this.axiosRequest(templateURL, {
        expiryDate: {
          startDate: new Date(moment(this.expiryDate.startDate).format('YYYY-MM-DD 00:00:00')).toISOString(),
          endDate: new Date(moment(this.expiryDate.endDate).format('YYYY-MM-DD 23:59:59')).toISOString()
        },
        integrated_numbers: this.integrated_numbers,
        phonenumberIds: this.integrated_numbers,
        waId: this.waId
      });
    },
    async getNumberIntegrationList() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    },
    async getOnLoadMessageLogs() {
      var getTemp = await this.getMessageAnalytics();
      this.tables = this.cumulateUserWise(getTemp.data || []);
    },
    handleOutsideClick(event) {
      const wrap = this.$refs.numberSelectWrap;
      if (wrap && !wrap.contains(event.target)) {
        this.numberDropdownOpen = false;
      }
    },
    normalizeId(value) {
      return (value ?? '').toString();
    },
    getPhoneLabelById(id) {
      const normalizedId = this.normalizeId(id);
      const option = this.phones.find((row) => this.normalizeId(row.phonenumberId) === normalizedId);
      if (!option) return normalizedId;
      return `${option.name} (+91 ${option.phonenumber})`;
    },
    isNumberSelected(id) {
      const normalizedId = this.normalizeId(id);
      return this.integrated_numbers.includes(normalizedId);
    },
    toggleNumberSelection(id) {
      const normalizedId = this.normalizeId(id);
      if (this.isNumberSelected(normalizedId)) {
        this.integrated_numbers = this.integrated_numbers.filter((value) => value !== normalizedId);
      } else {
        this.integrated_numbers = [...this.integrated_numbers, normalizedId];
      }
      this.getOnLoadMessageLogs();
    },
    removeSelectedNumber(id) {
      const normalizedId = this.normalizeId(id);
      this.integrated_numbers = this.integrated_numbers.filter((value) => value !== normalizedId);
      this.getOnLoadMessageLogs();
    },
    clearSelectedNumbers() {
      if (!this.integrated_numbers.length) return;
      this.integrated_numbers = [];
      this.numberSearch = "";
      this.getOnLoadMessageLogs();
    },
    getVisiblePhones() {
      return this.phones.filter((option) => option.msg91 == false);
    },
    filteredPhoneOptions() {
      const keyword = (this.numberSearch || '').toLowerCase().trim();
      const visible = this.getVisiblePhones();
      if (!keyword) return visible;
      return visible.filter((option) => {
        const name = (option.name || '').toLowerCase();
        const phone = (option.phonenumber || '').toString().toLowerCase();
        const phoneId = this.normalizeId(option.phonenumberId).toLowerCase();
        return name.includes(keyword) || phone.includes(keyword) || phoneId.includes(keyword);
      });
    },
    cumulateUserWise(rows = []) {
      const userMap = {};
      rows.forEach((row) => {
        const username = ((row.username || '').toString().trim()) || 'Unknown';
        if (!userMap[username]) {
          userMap[username] = {
            username,
            submitted: 0,
            delivered: 0,
            read: 0
          };
        }
        userMap[username].submitted += Number(row.total) || 0;
        userMap[username].delivered += Number(row.delivered) || 0;
        userMap[username].read += Number(row.read) || 0;
      });
      return Object.values(userMap).sort((a, b) => b.delivered - a.delivered);
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

.bg-lightblue {
  background-color: lightblue;
}

.number-select-wrap {
  position: relative;
  width: 100%;
  min-width: 0;
}

.select2-like {
  min-height: 38px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: #fff;
  padding: 4px 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  cursor: text;
}

.select2-like-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  width: 100%;
  min-height: 28px;
}

.select2-like-placeholder {
  color: #6c757d;
  font-size: 13px;
}

.select2-like-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e9ecef;
  border-radius: 3px;
  padding: 2px 6px;
  font-size: 12px;
}

.chip-close {
  border: none;
  background: transparent;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.select2-like-input {
  border: none;
  outline: none;
  min-width: 140px;
  flex: 1;
  font-size: 13px;
}

.select2-like-clear {
  border: none;
  background: transparent;
  color: #007bff;
  font-size: 12px;
  cursor: pointer;
  align-self: flex-end;
}

.select2-like-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 4px;
  max-height: 240px;
  overflow-y: auto;
  padding: 6px 8px;
}

.select2-like-option {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  cursor: pointer;
}

.select2-like-empty {
  color: #6c757d;
  font-size: 13px;
  padding: 6px 0;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
